module.exports = __webpack_public_path__ + "static/media/reactoonz.playngo.07266a31.jpeg";